$(document).ready(() => {
  var swiper = new Swiper(".swiper-reassurance", {
    slidesPerView: 1,
    slidesPerGroup:1,
    watchOverflow: true,
    breakpoints: {
      576: {
        slidesPerView: 2,
        slidesPerGroup:1,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      992: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 1,
      }
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });
  
  
  var swiper = new Swiper(".swiper-products", {
    slidesPerView: 1,
    slidesPerGroup:1,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        slidesPerGroup:1,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 1,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
      

  var swiper = new Swiper(".swiper-featured-products", {
    slidesPerView: "auto",
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  var swiper = new Swiper(".swiper-crossselling", {
    slidesPerView: 2,
    slidesPerGroup: 1,
    watchOverflow: true,
    breakpoints: {
      576: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      1200: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      }
    },
    navigation: {
      nextEl: '.swiper-crossselling-button-next',
      prevEl: '.swiper-crossselling-button-prev',
    },
  });
  
});
